import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { GuestGuard } from 'src/auth/guard';

import { SplashScreen } from 'src/components/loading-screen';

// JWT
// const JwtLoginPage = lazy(() => import('src/pages/auth/jwt/login'));

const authJwt = {
  element: (
    <GuestGuard>
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    </GuestGuard>
  ),
  children: [
    {
      path: 'login',
      element: (
        <SplashScreen>
          <div>JWT LOGIN PAGE</div>
        </SplashScreen>
      ),
    },
  ],
};

export const authRoutes = [
  {
    path: 'auth',
    children: [authJwt],
  },
];
